/**
 * @class
 * @description Wrapper for timeout methods
 */
export default class Timeout {
  /**
   * Wait time
   * @param {number} time In seconds
   */
  constructor(time) {
    this._time = time * 1000
  }

  /**
   * Synchronous timeout with promise
   * @param {Object} data Data to return when the timeout is fulfilled
   *
   * @returns {Promise<Object>}
   */
  synchronous(data) {
    return new Promise(resolve => {
      this.setTimeout(() => resolve(data))
    })
  }

  /**
   * Simple setTimeout
   * @param {function} callback
   */
  setTimeout(callback) {
    if (this._timeoutId) this.remove()

    this._timeoutId = setTimeout(() => {
      callback()
    }, this._time)
  }

  /**
   * Clear timeout
   */
  remove() {
    clearTimeout(this._timeoutId)
  }
}